import styled from "styled-components";

import { InvoicesContainer } from "../Invoices/InvoicesStyles";

export const TableHeader = styled.div`
  ${(props) => `
    color: ${props.theme.colors.blackTextBody + props.theme.transparencies.p58};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-align: center;

  .importer-header {
    margin-left: 0.6rem;
    text-align: left;
  }

  .checkbox-volante {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const VctVolantesContainer = styled(InvoicesContainer)``;

export const ButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 2rem 0rem;
  width: 100%;

  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
  }
`;

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    color: ${props.theme.colors.white};
    cursor: ${props.isLoading ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  min-height: 6rem;
  width: 25%;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: not-allowed;
  }

  img {
    height: 5rem;
    width: 5rem;
  }
`;

export const FakeRow = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-size: 1400px 104px;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 8%, #f6f6f6 18%, #ffffff 33%);
  border-radius: 1rem;
  height: 6.3rem;
  margin: 1rem 0;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -668px 0;
    }
    100% {
      background-position: 668px 0;
    }
  }
`;
